import css from './NewsletterSection.module.css';
import { Card, Input } from '@mui/material';
import Button from '../../../components/Button/Button';

const NewsletterSection = () => (
  <section className={css.newsletterWrapper}>
    <Card className={css.newsletterCard}>
      <div className={css.newsletterGradient}></div>
      <div>
        <div className={css.newsletterHeading}>Stay Updated on Fitness Trends</div>
        <p className={css.newsletterText}>
          Get the latest fitness tips, new facility openings, and exclusive offers delivered to your
          inbox.
        </p>
        <div className={css.newsletterForm}>
          <Input type="email" placeholder="Enter your email" className={css.newsletterInput} />
          <Button className={css.newsletterButton} size="lg">
            Subscribe
          </Button>
        </div>
        <p className={css.newsletterText} style={{ fontSize: '0.75rem' }}>
          By subscribing, you agree to our Privacy Policy and consent to receive updates from
          FootFall.
        </p>
      </div>
    </Card>
  </section>
);
export default NewsletterSection;
